import {
  TableBody as BaseTableBody,
  type TableCellProps as TableBodyCellProps,
  type TableBodyProps as BaseTableBodyProps,
  type TableRowProps,
} from '@shared/components';

import TableRow from './table-row';

export interface TableBodyRow extends Omit<TableRowProps, 'children'> {
  children: TableBodyCellProps[];
  collapsible?: boolean;
}

export interface TableBodyProps {
  rows: TableBodyRow[];
  slotProps?: {
    tableBody?: BaseTableBodyProps;
    tableBodyRow?: TableRowProps;
    tableBodyCell?: TableBodyCellProps;
  };
}

export default function TableBody(props: Readonly<TableBodyProps>) {
  const { rows, slotProps = {} } = props;
  const {
    tableBody: tableBodyProps,
    tableBodyRow: tableBodyRowProps = {},
    tableBodyCell: tableBodyCellProps = {},
  } = slotProps;

  return (
    <BaseTableBody {...tableBodyProps}>
      {rows.map(({ id, ...rowProps }, index) => (
        <TableRow
          key={id ?? `table-generator-row-${index}`}
          id={id}
          {...rowProps}
          tableRow={tableBodyRowProps}
          tableCell={tableBodyCellProps}
        />
      ))}
    </BaseTableBody>
  );
}
